module.exports = __webpack_public_path__ + "img/schullogo-red.90b500b3.png";